import React from 'react';
import PropTypes from 'prop-types';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

class BookingsModalDetails extends React.Component{

    state = {
        requiredTags: this.props.booking.requiredTags ? this.props.booking.requiredTags.split(',') : []
    };

    handleChange = (tags, key) => {
        this.setState({[key]: tags});
        this.props.updateBooking(key, tags.join(','));
    };

    render() {
        return (
            <div className="tab-panel">
                <div className="column">
                    <label htmlFor="bookingTitle">Title</label>
                    <input id="bookingTitle" defaultValue={this.props.booking.name} onChange={e => this.props.updateBooking("name", e.target.value)} placeholder="Enter title" />

                    <label htmlFor="bookingDescription">Short description</label>
                    <textarea id="bookingDescription" defaultValue={this.props.booking.bookingDescription} onChange={e => this.props.updateBooking("bookingDescription", e.target.value)} placeholder="Enter short description"></textarea>

                    <label htmlFor="bookingDetailedDescription">Detailed description</label>
                    <textarea id="bookingDetailedDescription" defaultValue={this.props.booking.longDescription} onChange={e => this.props.updateBooking("longDescription", e.target.value)} placeholder="Enter detailed description"></textarea>

                </div>
                <div className="column">
                    <label htmlFor="bookingCost">Cost</label>
                    <input id="bookingCost" defaultValue={this.props.booking.cost} onChange={e => this.props.updateBooking("cost", e.target.value)} placeholder="Enter cost, e.g. £150" />

                    <label htmlFor="bookingDuration">Duration</label>
                    <input id="bookingDuration" defaultValue={this.props.booking.duration} onChange={e => this.props.updateBooking("duration", e.target.value)} placeholder="Enter duration, e.g. 30 mins" />

                    <label htmlFor="maxAttendees">Max attendees</label>
                    <input id="maxAttendees" defaultValue={this.props.booking.maxAttendees} onChange={e => this.props.updateBooking("maxAttendees", e.target.value)} type="number" min="1" placeholder="Enter max attendees, e.g. 12" />

                    <label htmlFor="acuityID">Acuity appt id</label>
                    <input id="acuityID" defaultValue={this.props.booking.apptID} onChange={e => this.props.updateBooking("apptID", e.target.value)} placeholder="Enter Acuity appt id, e.g. 5337217" />

                    <label htmlFor="isID">Infusionsoft product id</label>
                    <input id="isID" defaultValue={this.props.booking.isProductId} onChange={e => this.props.updateBooking("isProductId", e.target.value)} placeholder="Enter Infusionsoft product id, e.g. 1148" />

                    <label htmlFor="tagDrop">Tag to drop on purchase</label>
                    <input id="tagDrop" defaultValue={this.props.booking.tagToAdd} onChange={e => this.props.updateBooking("tagToAdd", e.target.value)} placeholder="Enter tag number" />

                    <label>Require these tags to allow booking</label>
                    <TagsInput value={this.state.requiredTags[0] === "" ? [] : this.state.requiredTags} onChange={tags => this.handleChange(tags, 'requiredTags')} />

                </div>
            </div>
        );
    }
}

BookingsModalDetails.propTypes = {
    booking: PropTypes.object.isRequired,
    updateBooking: PropTypes.func.isRequired
}

export default BookingsModalDetails;


/** WEBPACK FOOTER **
 ** ./src/components/BookingsModalDetails.js
 **/